import { render, staticRenderFns } from "./RedeemedAwardsHistory.vue?vue&type=template&id=1f3fec88&scoped=true"
import script from "./RedeemedAwardsHistory.vue?vue&type=script&lang=js"
export * from "./RedeemedAwardsHistory.vue?vue&type=script&lang=js"
import style0 from "./RedeemedAwardsHistory.vue?vue&type=style&index=0&id=1f3fec88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fec88",
  null
  
)

export default component.exports